import { render, staticRenderFns } from "./Tekshiruvlar.vue?vue&type=template&id=0cbc4d42"
import script from "./Tekshiruvlar.vue?vue&type=script&lang=js"
export * from "./Tekshiruvlar.vue?vue&type=script&lang=js"
import style0 from "./Tekshiruvlar.vue?vue&type=style&index=0&id=0cbc4d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports